import styled from 'styled-components';
import { ButtonIconBackground } from '../../inputs/buttons/ButtonIconBackground';
import { Typography } from '../../display/Typography';

export const ContainerOperator = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.s}rem;
`;

export const ContainerDescription = styled.div`
  width: 100%;
  max-width: 147.8rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 100%;
  }
`;

export const ContainerWithButton = styled.div`
  display: flex;
  justify-content: space-between;
`;
/**
 * Los botones de cabecera van juntos. Sin esto el `space-between` del
 * contenedor reparte a TODOS sus hijos, así que al añadir el segundo botón el
 * primero se quedaba pegado al título y el otro contra el borde derecho.
 */
export const HeaderButtonsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
  /* En tablet los dos botones no caben en una línea y bajan. Sin estas dos
     reglas el grupo se estira a lo alto del contenedor —que es una fila
     flex— y las dos líneas se reparten ese hueco: quedaban separadas por
     media pantalla. */
  align-self: flex-start;
  align-content: flex-start;
  justify-content: flex-end;
`;
export const ContainerCampaign = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    flex: 1;
    min-width: 0;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    max-width: 27rem;
  }
`;

export const ContainerSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xxs}rem;
  margin-bottom: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const StyledTypography = styled(Typography)`
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const Editicon = styled(ButtonIconBackground)`
  width: 3.4rem;
  height: 3.4rem;
`;
